import { ZCatalogRecord } from "./ZCatalogRecord";

export const getRecordTitle = ({ name, displayId }: ZCatalogRecord): string =>
  name ?? `Запись ${displayId}`;
